import React, { useEffect, useRef, createElement } from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { motion } from 'framer-motion';
declare global {
  interface Window {
    _hw?: any;
  }
}
const CHERRY_SCRIPT_SRC = 'https://files.withcherry.com/widgets/widget.js';
const CHERRY_FONTS_HREF = 'https://fonts.googleapis.com/css2?family=Playfair+Display:wght@200..900&family=Montserrat:wght@200..900&display=swap';
export function Cherry() {
  const {
    t,
    lang
  } = useLanguage();
  const initializedRef = useRef(false);
  const easeOutCubic = [0.33, 1, 0.68, 1];
  useEffect(() => {
    if (typeof window === 'undefined') return;
    // 1) Inject Cherry's required font preload (idempotent)
    if (!document.querySelector(`link[href="${CHERRY_FONTS_HREF}"]`)) {
      const fontLink = document.createElement('link');
      fontLink.rel = 'stylesheet';
      fontLink.href = CHERRY_FONTS_HREF;
      document.head.appendChild(fontLink);
    }
    // 2) Define the _hw queue stub before the script loads, per Cherry's loader pattern
    if (!window._hw) {
      window._hw = function () {
        ;
        (window._hw.q = window._hw.q || []).push(arguments);
      };
    }
    // 3) Initialize the widget — re-runs on language change to swap ES/EN
    window._hw('init', {
      debug: false,
      variables: {
        slug: 'lipo-laser-beverly-hills-llc',
        name: 'Lipo Laser Beverly Hills LLC',
        images: [37],
        customLogo: 'https://lipolaserbeverlyhills.com/',
        defaultPurchaseAmount: 5000,
        customImage: '',
        imageCategory: 'plastics',
        language: lang === 'es' ? 'es' : 'en'
      },
      styles: {
        primaryColor: '#B8935A',
        secondaryColor: '#B8935A10',
        fontFamily: 'Montserrat',
        headerFontFamily: 'Playfair Display'
      }
    }, ['calculator']);
    // 4) Inject the actual widget script ONCE
    if (!document.querySelector(`script[src="${CHERRY_SCRIPT_SRC}"]`)) {
      const script = document.createElement('script');
      script.src = CHERRY_SCRIPT_SRC;
      script.async = true;
      script.id = '_hw';
      document.body.appendChild(script);
    }
    initializedRef.current = true;
  }, [lang]);
  return <section id="financiamiento" className="py-20 lg:py-28 bg-brand-cream relative overflow-hidden" data-id="element-72">
      <div className="container mx-auto px-6" data-id="element-73">
        <div className="text-center max-w-2xl mx-auto mb-14" data-id="element-74">
          <span className="text-brand-dark/50 font-medium tracking-[0.25em] text-xs uppercase mb-6 block" data-id="element-75">
            {t('cherry.eyebrow')}
          </span>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif font-light text-brand-dark mb-6 tracking-tight" data-id="element-76">
            {t('cherry.heading')}
          </h2>
          <p className="text-brand-dark/60 font-light text-lg" data-id="element-77">
            {t('cherry.subheading')}
          </p>
          <div className="w-12 h-px bg-brand-gold mx-auto mt-10" data-id="element-78"></div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 1,
        ease: easeOutCubic
      }} className="max-w-3xl mx-auto bg-white rounded-[2rem] border border-brand-stone/40 p-6 lg:p-10 shadow-sm" data-id="element-79">
          {/* Cherry widget mounts here */}
          <div id="calculator" key={lang} className="cherry-widget-anchor" data-id="element-80"></div>
        </motion.div>

        <div className="text-center mt-10 max-w-xl mx-auto" data-id="element-81">
          <p className="text-[10px] font-medium tracking-widest uppercase text-brand-dark/40" data-id="element-82">
            {t('cherry.disclaimer')}
          </p>
        </div>
      </div>
    </section>;
}